import React, { useState, useEffect } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { FaLayerGroup, FaCheck } from "react-icons/fa";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/class-settings-modals.css";

//Created By Cursor
const MdlAddSection = ({ actionClose, action2 }) => {
  const token = localStorage.getItem("token");
  const [loggedIn] = useState(token !== null);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);
  const [sectionList, setSectionList] = useState([]);
  const [selectedSectionId, setSelectedSectionId] = useState("");
  const [selectedSectionName, setSelectedSectionName] = useState("");

  const handleClose = () => {
    setShow(false);
    actionClose();
  };

  useEffect(() => {
    getSectionMasterList();
  }, []);

  //Created By Cursor
  const getSectionMasterList = () => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getSectionMasterList.php`;

    axios
      .get(URL, { params: { school_code: SCHOOL_CODE } })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          setSectionList(response.data || []);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
        myToast.notify_error("Failed to load sections");
      });
  };

  const handleSubmit = () => {
    if (!selectedSectionId) {
      myToast.notify_warning("Please select a section");
      return;
    }
    action2({
      section_id: selectedSectionId,
      section_name: selectedSectionName,
    });
    handleClose();
  };

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={false}
      size="md"
      centered
      dialogClassName="cls-mdl-root"
      aria-labelledby="add-section-title"
    >
      <Modal.Header closeButton>
        <div>
          <Modal.Title id="add-section-title">
            <FaLayerGroup />
            Add Section
          </Modal.Title>
          <span className="cls-mdl-sub">
            Choose a section to attach to this class
          </span>
        </div>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <MyLoader />
        ) : (
          <div className="cls-mdl-panel">
            <label className="cls-mdl-field full">
              <span>Section *</span>
              <select
                value={selectedSectionId}
                onChange={(e) => {
                  const id = e.target.value;
                  setSelectedSectionId(id);
                  const sel = sectionList.find(
                    (s) => String(s.section_id) === String(id)
                  );
                  setSelectedSectionName(sel ? sel.section_name : "");
                }}
              >
                <option value="">Select Section</option>
                {sectionList.map((section) => (
                  <option key={section.section_id} value={section.section_id}>
                    {section.section_name}
                  </option>
                ))}
              </select>
            </label>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button className="cls-mdl-btn-ghost" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          className="cls-mdl-btn-cta"
          onClick={handleSubmit}
          disabled={loading}
        >
          <FaCheck style={{ marginRight: 6 }} />
          Add Section
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MdlAddSection;
